import PropTypes from 'prop-types'
import React from 'react'
import FlyoutAnchor from '#components/m/Flyout/FlyoutAnchor'
import {FlyoutPosition} from '#components/m/Flyout/FlyoutPosition'
import {FlyoutPivot} from '#components/m/Flyout/FlyoutPivot'
import Input from '#components/a/form/Input'
import MonthList from './MonthList'
import {getMonth, getYear, format} from 'ag-common/facades'
import YearHeader from '#components/m/MonthPicker/YearHeader'

function MonthPicker({
  selectedDate,
  selectedMonths,
  markedMonths,
  onSelectDate,
  flyoutVisible,
  onFlyoutVisibilityChanged,
  isMonthOnly,
}) {
  const onClickMonth = month => {
    onSelectDate(month, getYear(selectedDate), true)
  }

  const increaseYear = () => {
    onSelectDate(getMonth(selectedDate), getYear(selectedDate) + 1, false)
  }

  const decreaseYear = () => {
    onSelectDate(getMonth(selectedDate), getYear(selectedDate) - 1, false)
  }

  return (
    <FlyoutAnchor
      flyoutPosition={FlyoutPosition.bottom}
      flyoutPivot={FlyoutPivot.dynamic}
      flyoutDistance={15}
      openSync={flyoutVisible}
      flyoutVisibilityChanged={onFlyoutVisibilityChanged}
      flyoutContent={
        <>
          {!isMonthOnly && (
            <YearHeader currentYear={getYear(selectedDate)} decreaseYear={decreaseYear} increaseYear={increaseYear} />
          )}
          <MonthList monthChanged={onClickMonth} markedMonths={markedMonths} selectedMonths={selectedMonths} />
        </>
      }
      startWidth={320}
      startHeight={470}>
      <Input isReadonly value={format(selectedDate, isMonthOnly === true ? 'MMMM' : 'MMMM yyyy')} />
    </FlyoutAnchor>
  )
}

MonthPicker.propTypes = {
  flyoutVisible: PropTypes.bool,
  onFlyoutVisibilityChanged: PropTypes.func,
  onSelectDate: PropTypes.func,
  selectedDate: PropTypes.instanceOf(Date),
  selectedMonths: PropTypes.arrayOf(PropTypes.number),
  markedMonths: PropTypes.arrayOf(PropTypes.number),
  isMonthOnly: PropTypes.bool,
}

export default MonthPicker
